import React from "react";
import { Container, Button, Row, Col, Grid } from "react-bootstrap";
import BottomScrollListener from "react-bottom-scroll-listener";

const DashboardView = ({
  search_key,
  SearchTerm,
  results,
  SelectFaver,
  faver_data,
  contacts,
  selectContact,
  changeComment,
  faver,
  user,
  sendFaver,
  error,
  isLoading,
  replaceImage,
  getItem,
  handleScroll,
  selected_faver,
  changeFaver,
  toggleWriteReviewModal,
  full_name,
  changeFullName,
  getSearch,
  continue_scroll,
  search,
  btn_disable,
  webSearchActive,
  webSearch,
  searchingInWeb,
  resultsWeb,
  selectNewFaver,
  selected_optionWeb,
  useThisPage,
  creating_item,
  returnViewDefault,
  failIframe,
  openContentWindow,
  webSearchTerm,
  emptyFaverResults,
}) => (
  <div className="main">
    <div className="dashboard container-fluid" style={{ height: "100%" }}>
      <div className="div-header">
        <Grid>
          {/** Requester */}
          <Row>
            <Col xs={12}>
              {(emptyFaverResults && selected_optionWeb) ?
                <div className="section-category">
                  <Row>
                    <Col xs={1} sm={1} md={1} className="mtop-10">
                      <h5
                        className="margin0"
                        style={{ cursor: "pointer" }}
                        onClick={returnViewDefault}
                      >
                        <i className="glyphicon glyphicon-chevron-left"></i>
                        <span className="button-back-websearch">Back</span>
                      </h5>
                    </Col>
                    <Col xs={10} sm={10} md={10}>
                      <img
                        src="/assets/img/logo_faver.png"
                        className="center-block mtop-20 mbottom-20 logo-search-web"
                      />
                    </Col>
                    <Col
                      xs={12}
                      sm={12}
                      md={12}
                    >
                      <p
                        style={{ textAlign: "center" }}
                        className="subtitle-user"
                      >
                        Is this what you're looking for?
                      </p>
                    </Col>
                  </Row>
                </div>
                : webSearchActive ? (
                  // web search head
                  <div className="section-category">
                    <Row>
                      <Col xs={1} sm={1} md={1} className="mtop-10">
                        <h5
                          className="margin0"
                          style={
                            webSearchActive
                              ? { cursor: "pointer" }
                              : { display: "none" }
                          }
                          onClick={
                            selected_optionWeb
                              ? () => selectNewFaver(false)
                              : returnViewDefault
                          }
                        >
                          <i className="glyphicon glyphicon-chevron-left"></i>
                          <span className="button-back-websearch">Back</span>
                        </h5>
                      </Col>
                      <Col xs={10} sm={10} md={10}>
                        <img
                          src="/assets/img/logo_faver.png"
                          className="center-block mtop-20 mbottom-20 logo-search-web"
                        />
                      </Col>
                      <Col
                        xs={12}
                        sm={12}
                        md={12}
                        className={selected_optionWeb ? "hidden" : null}
                      >
                        <p
                          style={{ textAlign: "center" }}
                          className="subtitle-user"
                        >
                          Couldn’t find what you’re looking for?
                        </p>
                        <p
                          style={{ textAlign: "center" }}
                          className="subtitle-user"
                        >
                          Search the web for your recommendation, and we’ll help
                          you send it to {user.first_name}!
                        </p>
                      </Col>
                      <Col
                        xs={12}
                        sm={12}
                        md={12}
                        className={!selected_optionWeb ? "hidden" : null}
                      >
                        <p
                          style={{ textAlign: "center" }}
                          className="subtitle-user"
                        >
                          Is this what you're looking for?
                        </p>
                      </Col>
                    </Row>
                  </div>
                ) : (
                  // head for normal search and item selection
                  <div className="section-category">
                    <p className="section-title mtop-40 mbottom-20">
                      Welcome to FAVER
                    </p>
                    <Row>
                      <Col xs={3} sm={2} md={2} lg={1}>
                        <div className="outer-border">
                          <div
                            className="col-thumbail"
                            style={{ backgroundImage: user.user_img_url }}
                          ></div>
                        </div>
                      </Col>
                      <Col xs={9} sm={10} md={10} lg={11} className="mtop-10">
                        {/** Shows the icon and the name of the category */}
                        {/*
									(faver_data.category_id) ?
									<div className="pull-right txt-white">
										<img src={faver_data.category_id.icon} style={{ height: "24px", marginRight: "10px" }} />
										{faver_data.category_id.name}
									</div>
									: null
								*/}

                        {/** User info*/}
                        <div>
                          <p className="title-user">
                            {user.first_name + " " + user.last_name}
                          </p>
                          <p className="subtitle-user">
                            Wants a{" "}
                            {faver_data.category_id
                              ? faver_data.category_id.name
                              : ""}{" "}
                            recommendation from you!
                          </p>
                        </div>
                        <div className="title-description-full mtop-10">
                          {faver_data.comment}
                        </div>
                      </Col>
                    </Row>
                  </div>
                )}
            </Col>
          </Row>

          {/** Shows the icon and the name of the category */}
          {/*
				(faver_data.category_id) ?
					<Row>
					<Col xs={12}>
						<div className="section-category">
						<img src={faver_data.category_id.icon} style={{ height: "24px" }} />
						<p className="title-category">{faver_data.category_id.name}</p>
						</div>
					</Col>
					</Row>
					: null
				*/}

          {/** Search input section */}
          {/** Search tag */}
          {(selected_faver || (emptyFaverResults && selected_optionWeb)) ? (
            ""
          ) : webSearchActive ? (
            // web search
            <Row>
              <Col xs={12}>
                <div
                  className={
                    !selected_optionWeb ? "section-category mtop-25" : "hidden"
                  }
                >
                  <div>
                    {faver_data.category_id ? (
                      <img
                        src={faver_data.category_id.icon}
                        style={{ height: "24px", marginRight: "10px" }}
                      />
                    ) : null}

                    <input
                      type="text"
                      onKeyPress={(e) => webSearch(e)}
                      placeholder="Search or paste a link"
                      className="input-form"
                    />
                  </div>
                </div>
              </Col>
            </Row>
          ) : (
            // normal search
            <Row>
              <Col xs={12}>
                <div className="section-category mtop-25">
                  <p className="section-subtitle">
                    What{" "}
                    {faver_data.category_id ? faver_data.category_id.name : ""}{" "}
                    do you suggest for {user.first_name}?
                  </p>
                  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    {faver_data.category_id ? (
                      <img
                        src={faver_data.category_id.icon}
                        style={{ height: "30px", marginRight: "10px", marginTop: "-13px" }}
                      />
                    ) : null}

                    <input
                      autoFocus
                      type="text"
                      onChange={SearchTerm}
                      placeholder="Type your recommendation"
                      className="input-form"
                    />
                  </div>
                </div>
              </Col>
            </Row>
          )}
        </Grid>
      </div>
      <Grid>
        {/** Logo image */}
        {/*<Row className="header-logo">
            <Col xs={12}>
                <img src='/assets/img/logo_faver.png' className="center-block" style={{height: "24px"}} />
            </Col>
        </Row>*/}

        {/** From */}
        {/**
		<Row>
		  <Col xs={12}>
			<div className="section-category">
			  <div className="section-title mbottom-20">
				From
			  </div>
			  {contacts.length != 0 ?
				<select onChange={selectContact} style={{ background: '#2c2c2c', width: '100%', borderRadius: '20px', borderStyle: 'hidden', color: 'white', padding: '13px', marginBottom: '15px' }}>
				  {
					contacts.map(function (contact, index) {
					  return (
						<option value={contact.id} key={index}>
						  {contact.first_name + ' ' + contact.last_name}
						</option>
					  )
					})
				  }
				</select>
				:
				<div>
				  <input type='text' id='first_name' value={new_contact.first_name} onChange={changeNewContact} placeholder='First Name' className="input-form" />
				  <input type='text' id='last_name' value={new_contact.last_name} onChange={changeNewContact} placeholder='Last Name' className="input-form" />
				  <input type='text' id='phone' value={new_contact.phone} onChange={changeNewContact} placeholder='Phone' className="input-form" style={{ marginBottom: '0' }} />
				</div>
			  }
			</div>
		  </Col>
		</Row>
		*/}

        {/** Search section */}
        {!selected_faver &&
          !selected_optionWeb &&
          webSearchActive &&
          searchingInWeb ? (
          <Col className="search-section">
            <Row className="bottom-action container">
              <Col xs={12} className="section-btn">
                <div
                  className="section-item bt"
                  style={{ paddingRight: "0", paddingLeft: "0" }}
                >
                  <Row className="row-item">
                    <Col xs={3} sm={1} md={1}>
                      <p
                        className="text-results hidden-xs"
                        style={{ marginTop: "9px" }}
                      >
                        Results
                      </p>
                    </Col>
                    <Col xs={12} sm={11} md={11}>
                      <center>
                        <Button
                          onClick={() =>
                            toggleWriteReviewModal(
                              true,
                              "Want to add new items to FAVER?"
                            )
                          }
                          className="col-xs-12 btn button-wasnotfound"
                        >
                          Still don’t see what you’re looking for?
                        </Button>
                      </center>
                    </Col>
                    <Col xs={3} sm={1} md={1} className="mtop-10">
                      <p
                        className="text-results visible-xs"
                        style={{ marginTop: "9px", marginBottom: '0px' }}
                      >
                        Results
                      </p>
                    </Col>
                  </Row>
                </div>
              </Col>
            </Row>
            {/** Map search results  */}
            <div className="search-results">
              {resultsWeb.length ? (
                <Col>
                  <Row style={{ marginBottom: "22px" }}>
                    <Col xs={12}>
                      <div className="dashboard-item-web">
                        <i
                          className="glyphicon glyphicon-globe"
                          style={{ marginRight: "3px" }}
                        ></i>
                        From the Web
                      </div>
                    </Col>
                  </Row>
                  {resultsWeb.map(function (item, index2) {
                    return (
                      <Row key={index2} style={{ marginBottom: "22px" }}>
                        <Col xs={12}>
                          <div className="dashboard-item-web hoverRow">
                            <Row
                              className="row-item"
                              onClick={() => selectNewFaver(item)}
                            >
                              <Col xs={12} sm={12} md={12}>
                                {item.title}
                              </Col>
                              <Col xs={12} sm={12} md={12}>
                                <a
                                  className="item-web-displayLink"
                                  target="_self"
                                >
                                  {item.displayLink}
                                </a>
                              </Col>
                              <Col xs={12} sm={12} md={12}>
                                {item.link}
                              </Col>
                            </Row>
                          </div>
                        </Col>
                      </Row>
                    );
                  })}
                </Col>
              ) : !isLoading ? (
                <Row>
                  <Col xs={12}>
                    <div className="section-category">
                      <center>No results found.</center>
                    </div>
                  </Col>
                </Row>
              ) : null}
              {/** Loader  */}
              {isLoading ? (
                <Row>
                  <Col xs={12}>
                    <div>
                      <center>
                        <p className="text-searching" style={{}}>
                          Searching...
                        </p>
                      </center>
                    </div>
                  </Col>
                </Row>
              ) : null}
            </div>
          </Col>
        ) : !selected_faver && search_key.length > 0 ? (
          <Col className="search-section">
            <Row className={emptyFaverResults ? "hidden" : "bottom-action container"}>
              <Col xs={12} className="section-btn">
                <div
                  className="section-item bt"
                  style={{ paddingRight: "0", paddingLeft: "0" }}
                >
                  <Row>
                    <Col xs={12} sm={4} md={3}>
                      <p
                        className="text-results  hidden-xs"
                        style={{ marginTop: "9px" }}
                      >
                        Results from FAVER database
                      </p>
                    </Col>
                    <Col xs={12} sm={8} md={9}>
                      <center>
                        <Button
                          onClick={() =>
                            toggleWriteReviewModal(
                              true,
                              "Want to add new items to FAVER?"
                            )
                          }
                          className="col-xs-12 btn button-wasnotfound"
                        >
                          Don't see it? Search the web here
                        </Button>
                      </center>
                    </Col>
                    <Col xs={12} sm={1} md={1} className="mtop-10">
                      <p
                        className="text-results visible-xs"
                        style={{ marginTop: "9px", marginBottom: '0px' }}
                      >
                        Results from FAVER database
                      </p>
                    </Col>
                  </Row>
                </div>
              </Col>
            </Row>

            {/** Category  */}
            {/*
			  (faver_data.category_id) ?
				<Row>
				  <Col xs={12}>
					<div className="section-category">
					  **<img src={faver_data.category_id.icon} style={{ height: "24px" }} />
					  <p className="title-category">{faver_data.category_id.name}</p>
					</div>
				  </Col>
				</Row>
				: null
			*/}

            {/** Map search results  */}
            <div className="search-results">
              {results.length ? (
                results.map(function (item, index2) {
                  return (
                    <Row key={index2} style={{ marginBottom: "22px" }}>
                      {/*<Row key={index2} onClick={() => SelectFaver(item)}>*/}
                      <Col xs={12}>
                        <div className="section-item hoverRow">
                          <Row
                            className="row-item"
                            onClick={() => SelectFaver(item)}
                          >
                            <Col xs={6} sm={3} md={2} className="vertical-auto">
                              <img
                                src={
                                  item.image_url != null
                                    ? item.image_url
                                    : item.thumbnail_url != null
                                      ? item.thumbnail_url
                                      : "/assets/img/icons/placeholderAlbum.png"
                                }
                                onError={(e) => replaceImage(e)}
                                className="thumbail-item"
                                style={{ resizeMode: "contain" }}
                              />
                            </Col>
                            <Col
                              xs={6}
                              sm={7}
                              md={9}
                              style={{ paddingLeft: "0", paddingRight: "0" }}
                            >
                              <p className="title-item">{item.name}</p>
                              <p className="title-description">
                                {item.description}
                              </p>
                              <Button
                                onClick={() => SelectFaver(item)}
                                disabled={btn_disable}
                                className="col-xs-12 btn btn-faver no-border pbottom"
                              >
                                Select{" "}
                                <img
                                  src="/assets/img/chevron-right.svg"
                                  style={{ marginLeft: "60px" }}
                                />
                              </Button>
                            </Col>
                            <Col xs={2} sm={2} md={1} className="checkmark">
                              {item.selected ? (
                                <img src="/assets/img/icons/checkmark_mint.png" />
                              ) : (
                                ""
                              )}
                            </Col>
                          </Row>
                        </div>
                      </Col>
                    </Row>
                  );
                })
              ) : (!isLoading && emptyFaverResults && !selected_optionWeb) ? (
                <Row>
                  <Col>
                    <Row style={{ marginBottom: "22px" }}>
                      <Col xs={12}>
                        <div className="dashboard-item-web">
                          <i
                            className="glyphicon glyphicon-globe"
                            style={{ marginRight: "3px" }}
                          ></i>
                          From the Web
                        </div>
                      </Col>
                    </Row>
                    {resultsWeb.map(function (item, index2) {
                      return (
                        <Row key={index2} style={{ marginBottom: "22px" }}>
                          <Col xs={12}>
                            <div className="dashboard-item-web hoverRow">
                              <Row
                                className="row-item"
                                onClick={() => selectNewFaver(item)}
                              >
                                <Col xs={12} sm={12} md={12}>
                                  {item.title}
                                </Col>
                                <Col xs={12} sm={12} md={12}>
                                  <a
                                    className="item-web-displayLink"
                                    target="_self"
                                  >
                                    {item.displayLink}
                                  </a>
                                </Col>
                                <Col xs={12} sm={12} md={12}>
                                  {item.link}
                                </Col>
                              </Row>
                            </div>
                          </Col>
                        </Row>
                      );
                    })}
                  </Col>
                </Row>
              ) : null}
              {/** Loader  */}
              {isLoading ? (
                <Row>
                  <Col xs={12}>
                    <div>
                      <center>
                        <p className="text-searching" style={{}}>
                          Searching...
                        </p>
                      </center>
                    </div>
                  </Col>
                </Row>
              ) : null}
            </div>
            {results.length && results.length == 20 ? (
              <Row style={{ marginTop: "10px", marginBottom: "30px" }}>
                <Col xs={12}>
                  <Button
                    onClick={() => search("scroll")}
                    disabled={btn_disable}
                    className="col-xs-12 btn btn-faver"
                  >
                    Load More
                  </Button>
                </Col>
              </Row>
            ) : null}
          </Col>
        ) : selected_faver ? (
          ""
        ) : selected_optionWeb ? (
          ""
        ) : (
          <Col className="search-section mtop-50">
            <Row className="">
              <Col xs={12} className="section-btn">
                <img
                  src="/assets/img/faver_logo.svg"
                  className="center-block"
                  style={{ height: "100%" }}
                />
              </Col>
            </Row>
          </Col>
        )}
        {/** Selected item */}
        {selected_faver ? (
          <div>
            <Row id="selected-faver">
              <Col xs={12}>
                <div className="section-item mtop-30 mbottom-30">
                  <Row className="row-item">
                    <Col xs={6} sm={2} md={2} className="vertical-auto">
                      <img
                        src={
                          selected_faver.image_url != null
                            ? selected_faver.image_url
                            : selected_faver.thumbnail_url != null
                              ? selected_faver.thumbnail_url
                              : "/assets/img/icons/placeholderAlbum.png"
                        }
                        onError={(e) => replaceImage(e)}
                        className="thumbail-item"
                        style={{ resizeMode: "contain" }}
                      />
                    </Col>
                    <Col
                      xs={6}
                      sm={10}
                      md={10}
                      style={{ paddingLeft: "0", paddingRight: "0" }}
                    >
                      <p className="title-item">{selected_faver.name}</p>
                      <p className="title-description">
                        {selected_faver.description}
                      </p>
                      <Button
                        onClick={() => changeFaver()}
                        className="col-xs-12 btn btn-link pbottom"
                      >
                        Change
                      </Button>
                    </Col>
                  </Row>
                </div>
              </Col>
            </Row>
            <Row
              style={{
                background: "#ffffff",
                marginLeft: "-42px",
                marginRight: "-42px",
              }}
            >
              <Col xs={12}>
                <div
                  className="section-category"
                  style={{ marginTop: "20px", paddingLeft: "40px" }}
                >
                  <p
                    style={{
                      color: "#000000",
                      fontSize: "16px",
                      fontWeight: 500,
                      marginBottom: 15,
                    }}
                  >
                    From
                    {error ? (
                      <center style={{ marginBottom: "20px", color: "red" }}>
                        {error.message}
                      </center>
                    ) : (
                      ""
                    )}
                  </p>
                  <input
                    type="text"
                    id="fullName"
                    value={faver.name}
                    onChange={changeFullName}
                    placeholder="Your name"
                    className="input-form"
                    style={{ width: "100%" }}
                  />
                </div>
              </Col>
            </Row>
            <Row
              style={{
                background: "#ffffff",
                marginLeft: "-42px",
                marginRight: "-42px",
              }}
            >
              <Col xs={12}>
                <div
                  className="section-category"
                  style={{ marginTop: "20px", paddingLeft: "40px" }}
                >
                  <p
                    style={{
                      color: "#000000",
                      fontSize: "16px",
                      fontWeight: 500,
                      marginBottom: 15,
                    }}
                  >
                    Message (optional)
                  </p>
                  <textarea
                    placeholder="Hey, I'd FAVER this to you because..."
                    style={{
                      width: "100%",
                      backgroundColor: "#ECECEC",
                      borderRadius: 20,
                      height: 70,
                      paddingHorizontal: 10,
                      color: "#424141",
                      fontSize: 18,
                      lineHeight: "21px",
                      fontWeight: "normal",
                      borderStyle: "hidden",
                      padding: "13px",
                    }}
                    value={faver.comment}
                    onChange={changeComment}
                  />
                </div>
              </Col>
            </Row>
            <Row
              style={{
                background: "#ffffff",
                marginLeft: "-42px",
                marginRight: "-42px",
              }}
            >
              <Col xs={12} className="mbottom-20">
                <div className="section-category" style={{ marginTop: "20px" }}>
                  <center>
                    <Button
                      onClick={sendFaver}
                      className="col-xs-12 btn btn-faver mbottom-20"
                    >
                      Send via<span style={{ fontWeight: "bold" }}> FAVER</span>
                    </Button>
                  </center>
                </div>
              </Col>
            </Row>
          </div>
        ) : null}
        {selected_optionWeb && !creating_item ? (
          <div className="container_preview_web mbottom-70">
            {/* preview metatags */}
            <Row>
              <Col xs={6} sm={4} md={4} className="mtop-20">
                <center>
                  <Col className="col-md-offset-1 col-sm-offset-1 col-md-10 col-sm-10 col-xs-12 no-padding">
                    <div className="content-img-searpreview ">
                      <img
                        src={selected_optionWeb.img_preview}
                        onError={(e) => replaceImage(e)}
                        style={{ width: "100%", height: "100%" }}
                      />
                    </div>
                  </Col>
                </center>
              </Col>
              <Col
                xs={6}
                sm={7}
                md={7}
                className="no-padding content-details-searpreview"
              >
                <Col md={12}>
                  <h3
                    className="mtop-10"
                    style={{ textAlign: "center", fontWeight: "bold" }}
                  >
                    {selected_optionWeb.title}
                  </h3>
                </Col>
                <Col md={12}>
                  <p className="margin0" style={{ textAlign: "center" }}>
                    {selected_optionWeb.description}
                  </p>
                </Col>
              </Col>
            </Row>

            <Col className="mtop-30">
              <Col style={{ marginTop: "10px" }}>
                <center>
                  <a
                    style={{ cursor: "pointer" }}
                    onClick={() => openContentWindow(selected_optionWeb.link)}
                  >
                    {selected_optionWeb.link}
                  </a>
                </center>
              </Col>
            </Col>
            <Col className="mtop-20">
              <Col style={{ marginTop: "10px" }}>
                <center>
                  <Button
                    type="button"
                    className="hidden-xs btn btn-text button-usepage"
                    onClick={useThisPage}
                  >
                    Use This Content
                  </Button>
                </center>
              </Col>
            </Col>
          </div>
        ) : null}
        {creating_item ? (
          <Row className="mtop-40">
            {error ? (
              <Col md={1}>
                <h5
                  className="margin0"
                  style={{ cursor: "pointer" }}
                  onClick={() => selectNewFaver(false)}
                >
                  <i className="glyphicon glyphicon-chevron-left"></i> Back
                </h5>
              </Col>
            ) : null}
            <Col xs={12} className="section-btn">
              <img
                src="/assets/img/logo_faver.png"
                className="center-block mtop-20  mbottom-20"
                style={{ width: "270px" }}
              />
            </Col>
            {error ? (
              <Col xs={12}>
                <center style={{ marginBottom: "20px", color: "red" }}>
                  {error.message}
                </center>
              </Col>
            ) : (
              <Col xs={12}>
                <p style={{ textAlign: "center" }} className="subtitle-user">
                  Generating item from page.
                </p>
                <p style={{ textAlign: "center" }} className="subtitle-user">
                  this may take a second.
                </p>
              </Col>
            )}
          </Row>
        ) : null}
        {/*
			(continue_scroll) ?
				<BottomScrollListener onBottom={() => search('scroll')} />
			:
				""
		*/}
      </Grid>
    </div>
    <div className={selected_optionWeb ? "dashboard-footer-base" : "hidden"}>
      <center>
        <Button
          type="button"
          className="visible-xs btn btn-text button-usepage"
          onClick={useThisPage}
        >
          Use This Content
        </Button>
      </center>
    </div>
    <div className={(emptyFaverResults && !selected_optionWeb) ? "dashboard-footer-base" : "hidden"}>
      <center>
        <Button
          onClick={() =>
            toggleWriteReviewModal(
              true,
              "Want to add new items to FAVER?"
            )
          }
          className="btn button-emptyFaverResults"
        >
          Don’t see what you’re looking for? Click here
        </Button>
      </center>
    </div>
  </div>
);

export default DashboardView;



// WEBPACK FOOTER //
// ./src/client/views/dashboard/DashboardView.js